// Time Formats
export const TIME_FORMAT_EN = 'MMMM Do YYYY, h:mm:ss a';
export const TIME_FORMAT_ES = 'D [de] MMMM [del] YYYY, h:mm:ss a'